import * as angular from 'angular';
import FdxTransformersDownloadModalontroller from './fdx-transformers-download-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-transformers-download-modal.styles.scss';

export const componentName = 'fdxTransformersDownloadModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-transformers-download-modal.template.html'),
	controller: FdxTransformersDownloadModalontroller,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
